<template>
	<div class="shouye-top">
		<div class="left">
			<div class="left-flex">
				<div>
					<span class="left-icon icon iconfont icon-qianbao">本月业绩</span>
					<a @click="numberShowClick" v-show="!numberShow" class="hide icon iconfont icon-kejian"></a>
					<a @click="numberShowClick" v-show="numberShow" class="hide icon iconfont icon-yincang"></a>
				</div>
				<div v-show="!numberShow" class="present-sum">
					{{topData.now_achievement}}
					<span class="icon iconfont icon-xiajiantou1" v-if="topData.now_achievement_reduce - topData.now_achievement > 0">{{topData.now_achievement_reduce - topData.now_achievement}}</span>
					<span class="icon iconfont icon-shangjiantou1" v-else>{{topData.now_achievement - topData.now_achievement_reduce}}</span>
				</div>
				<div v-show="numberShow" class="concealCss">*******</div>
			</div>
			
		</div>
		<div class="center">
			<div style="display: flex; width: 1220px;">
				<div class="center-top">
					<div class="left-flex center-box" v-for="(item,index) in centerTopList" :key='index'>
						<div>
							<span :class="'center-icon ' + item.icon"></span>
							<span>{{item.title}}</span>
							<a @click="numberShowClick" v-show="!numberShow" class="hide icon iconfont icon-kejian"></a>
							<a @click="numberShowClick" v-show="numberShow" class="hide icon iconfont icon-yincang"></a>
						</div>
						<div v-show="!numberShow" class="present-sum-center" @click="detailClick(index)">
							{{topData[item.key]}}
							<span class="icon iconfont icon-shangjiantou1" v-if="topData[item.reduce_key] > 0">{{topData[item.reduce_key]}}</span>
							<span class="icon iconfont icon-xiajiantou1" v-else>{{-topData[item.reduce_key]}}</span>
						</div>
						<div v-show="numberShow" class="concealCss_small">*****</div>
					</div>

				</div>
				<div class="right-box">
					<Select v-model="timePeriodOne" @on-change="loadData" style="width:70px">
						<Option v-for="item in timeList" :value="item.value" :key="item.value">{{ item.label }}</Option>
					</Select>
				</div>
			</div>
			<div class="center-bottom">
				<div class="blue_box" :class="{violet_box:item.name=='上门任务',green_box:item.name=='签约任务'}" v-for="(item,index) in taskSchedule" :key="index">
					<div style="display: flex; flex-direction: column;">
						<span>{{item.name}}</span>
						<span>{{topData[item.key]}}</span>
					</div>
					<div class="blue_box_right">
						<span >已完成{{topData[item.proportion_key]}}%</span>
	
						<div class="progress_box">
							<div :style="{width:topData[item.proportion_key]+'%'}" class="progress_line" :class="{violet_line:item.name=='上门任务',green_line:item.name=='签约任务'}"></div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="weather">
			<div>{{weathers.city}}</div>
			<div>{{weathers.reporttime}}</div>
			<div>{{weathers.temperature}}°C</div>
			<div>{{weathers.weather}}</div>
		</div>
	</div>
</template>

<script>
	import moment from 'moment'
	import {
		getWeather,
		getLocation,
		getTopHome
	} from '@/api/shouye'
	import {
		mapActions,
		mapGetters
	} from "vuex";
	export default {
		name: "ShouyeTop",
		computed: {
			...mapGetters(['token']),
		},
		data() {
			return {

				// 任务进度
				taskSchedule: [{
						name: '业绩任务',
						key: 'total_task_achievement',
						proportion_key: 'total_task_proportion',
					},
					{
						name: '上门任务',
						key: 'view_task_nums',
						proportion_key: 'view_task_proportion',
					},
					{
						name: '签约任务',
						key: 'sign_task_nums',
						proportion_key: 'sign_task_proportion',
					},
				],
				//获取到的天气数据
				weathers: {},
				locationAdcode: '', //获取当前位置的adcode
				numberShow: false, //数字隐藏
				timePeriodOne: '1',
				testClass: 'icon-xiajiantou1 decline',
				timeList: [
					{
						value: '1',
						label: '本月'
					}, {
						value: '2',
						label: '本季度'
					}, {
						value: '3',
						label: '本年'
					}
				],
				topData: {
					'now_achievement': 0, // 本月业绩
					'now_achievement_reduce': 0, // 上月业绩
					'total_achievement': 0, // 总业绩
					'total_task_achievement': 0, // 业绩任务数
					'total_task_proportion': 0, // 业绩任务完成比例
					'total_achievement_reduce': 0, // 总业绩上个期间的差值
					'client_nums': 0, // 跟进客户总数
					'client_nums_reduce': 0, // 跟进客户总数上个期间的差值
					'loan_money': 0, //放款总金额
					'loan_money_reduce': 0 ,//放款总金额上个期间的差值
					'loan_nums': 0, // 放款总数
					'loan_nums_reduce': 0, // 放款数上个期间的差值
					'join_nums': 0, // 进件总数
					'join_nums_reduce': 0, // 进件总数上个期间的差值
					'sign_nums': 0, // 签约数
					'sign_task_nums': 0, // 签约任务数
					'sign_nums_reduce': 0, // 签约任务数上个期间的差值
					'sign_task_proportion': 0, // 签约任务完成比例
					'view_nums': 0, // 上门数
					'view_nums_reduce': 0, // 上门数上个期间的差值
					'view_task_nums': 0, // 上门任务数
					'view_task_proportion': 0, // 上门任务完成比例
				},
				centerTopList: [{
						title: '放款(元)',
						icon: 'icon iconfont icon-qianbao',
						key: 'loan_money',
						reduce_key: 'loan_money_reduce',
					},
					{
						title: '放款(个)',
						icon: 'icon iconfont icon-qianyuejilu',
						key: 'loan_nums',
						reduce_key: 'loan_nums_reduce',
					},
					{
						title: '签约(笔)',
						icon: 'icon iconfont icon-shangmenfuwu',
						key: 'sign_nums',
						reduce_key: 'sign_nums_reduce',
					},
					{
						title: '上门(个)',
						icon: 'icon iconfont icon-shijianzhongbiao2',
						key: 'view_nums',
						reduce_key: 'view_nums_reduce',
					},
					{
						title: '客户量(个)',
						icon: 'icon iconfont icon-liebiao',
						key: 'client_nums',
						reduce_key: 'client_nums_reduce',
					},
				]
			}
		},
		created() {
			this.loadData();
			getLocation().then(res => {
				this.locationAdcode = res.data.adcode
				getWeather(this.locationAdcode).then(res => {
					this.weathers = res.data.lives[0]
					this.weathers.reporttime = moment().format('YYYY-MM-DD')
				})
			})
		},
		mounted() {
			let that = this;
			this.$EventBus.$on("getHomeData", () => {
				that.loadData();
			});
		},
		methods: {
			...mapActions([
				'handleLogOut',
			]),
			detailClick(index) {
				console.log(index)
			},
			async loadData() {
				let that = this;
				let data = {
					token: this.token,
					departmentId: window.localStorage['getTopDataDepartmentId'],
					userId: window.localStorage['getTopDataUserId']
				}
				data.timePeriodOne = this.timePeriodOne;
				let res = await getTopHome(that, data);
				that.topData = res.data;
			},
			numberShowClick() {
				this.numberShow = !this.numberShow
			}
		}
	}
</script>

<style scoped lang="less">
	.blue_box_right {
		display: flex;
		flex-direction: column;
		align-items: center;
		font-weight: normal;
		margin-left: 15px;
	}

	.center-bottom {
		display: flex;
		justify-content: space-between;
	}

	.progress_box {
		width: 220px;
		height: 15px;
		background-color: #FFFFFF;
		border-radius: 20px;
		display: flex;
		align-items: center;
		padding: 0 4px;
	}

	.progress_line {
		background-color: #0192FF;
		height: 60%;
		border-radius: 20px;
	}
	.violet_line {
		background-color: #9567E3;
	}
	.green_line {
		background-color: #78CE75;
	}

	.blue_box {
		background-color: #0192FF;
		width: 33%;
		height: 90px;
		color: #FFFFFF;
		font-size: 18px;
		font-weight: bold;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.violet_box {
		background-color: #9567E3;
	}
	.green_box {
		background-color: #78CE75;
	}

	.concealCss_small {
		font-size: 20px;
		font-weight: bold;
		color: #DFDBDB;
	}

	.concealCss {
		font-size: 30px;
		font-weight: bold;
		color: #DFDBDB;
	}

	.weather {
		height: 200px;
		background-color: #277dd3;
		width: 130px;
		border-radius: 10px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: space-around;

		div {
			color: #FFFFFF;
		}
	}

	.right {
		margin-right: 10px;
	}

	.center {
		width: 1220px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		margin-left: 10px;
		margin-right: 10px;
	}

	.center-top {
		display: flex;
	}

	.center-box {
		width: 220px;
		height: 90px;
		background-color: #FFFFFF;
	}

	.right-box {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 120px;
		height: 90px;
		background-color: #FFFFFF;
	}

	.shouye-top {
		display: flex;
	}

	.left {
		height: 200px;
		width: 300px;
		background-color: #FFFFFF;
		display: flex;
		flex-direction: column;
		justify-content: space-around;
	}

	.left-icon {
		color: #34A8FF;
		font-size: 18px;
	}

	.center-icon {
		color: #34A8FF;
		font-size: 15px;
	}

	.hide {
		color: #DFDBDB;
		margin-left: 10px;
	}

	.decline {
		color: #00B12E;
		font-size: 10px;
	}

	.rise {
		color: #ED4014;
		font-size: 10px;
	}

	.decline-center {
		color: #00B12E;
		font-size: 1px;
	}

	.present-sum {
		font-size: 30px;
		font-weight: bold;
		color: #515A6E;
	}

	.present-sum-center {
		font-size: 20px;
		font-weight: bold;
		color: #515A6E;
		text-align: center;
		cursor: pointer;
	}

	.left-flex {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}
	.icon-shangjiantou1{
		color: red;
	}
	.icon-xiajiantou1{
		color: green;
	}
</style>
